import { FC } from 'react'
import { useTranslation } from '../../../hooks/locale'
import { ErrorIllustrationIcon } from './error-icon'
import { Container, SVGContainer, Title, Description, StyledButton } from './styles'

interface ErrorCardProps {
    title?: string
    description?: string
    buttonText?: string
    onButtonClick?: () => void
}

const ErrorCard: FC<ErrorCardProps> = ({ title, description, buttonText, onButtonClick }) => {
    const { t } = useTranslation()

    return (
        <Container>
            <SVGContainer>
                <ErrorIllustrationIcon />
            </SVGContainer>
            <Title>{title || t('error.title')}</Title>
            <Description>{description || t('error.description')}</Description>
            {onButtonClick && <StyledButton onClick={onButtonClick}>{buttonText || t('error.retry')}</StyledButton>}
        </Container>
    )
}

export default ErrorCard
